/**
 * Valores iniciais do formulário de Evento.
 */
export const eventDefaults = {
    name: "",
    startDate: "",
    endDate: "",
    type: "evaluation", // "evaluation", "test" ou "extra"
    testType: "", // "fixed_time" ou "fixed_distance"
    fixedTime: "", 
    fixedDistance: "",
    badgeImageUrl: "", // URL da insígnia (apenas para eventos tipo "extra")
    rewardXp: "", // XP concedido ao ganhar a insígnia deste evento extra
    description: ""
};
